// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A4U9).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import { sessionsQuery } from '../../features/account/queries'
import { SessionsList } from '../../features/account/SessionsList'
import { Part } from '../../shared/shell/StatePart'

export const Route = createFileRoute('/account/devices')({
  staticData: { screenId: 'AccountSessionsScreen', access: 'signed in' },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(sessionsQuery()),
  component: AccountSessionsScreen,
})

function AccountSessionsScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid={ids.accountSessions.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('account.sessions.title')} />
      <Part testId={ids.accountSessions.skeleton}>
        <SessionsList />
      </Part>
    </main>
  )
}
